// Polyfill
import "intersection-observer";
import objectFitImages from "object-fit-images";
import closetPolyfill from "./lib/closet.polyfill";
objectFitImages();
closetPolyfill();

// Librally
// ---------------------------------------
// import Swiper, { Autoplay, Navigation } from 'swiper';
// import 'swiper/css';
// Swiper.use([Navigation,Autoplay]);

import Toggle from "./lib/Toggle";
// import ScrollObserver from "./lib/ScrollObserver";
// import { inview } from "./lib/inview";

import "./lib/smoothScroll";
import "./lib/accordion";
// import "./lib/scrollNavbar"; // navigation bar
// import "./lib/toggleSideVisible"; // single-template toggle sidebar visibility
// import "./lib/clipcopy"; // copyurl
// import "./lib/countfav"; // count favs
// import "./lib/toclist"; // set toc list
// import { doc } from "prettier";

(() => {
  /**
   * Toggle Menu
   */
  const globalToggle = new Toggle(".js-button-hamburger");
})();

document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("header");
  var headerHeight = header.offsetHeight;
  var headerFixed = document.querySelector(".l-header__fixed");

  window.addEventListener("scroll", function () {
    if (window.scrollY > headerHeight) {
      headerFixed.classList.add("is-view");
    } else {
      headerFixed.classList.remove("is-view");
    }
  });
});
// partnerページ料金体系タブ
$(function () {
  $(".jsTab").on("click", function () {
    const index = $(".jsTab").index(this);
    $(".jsTab").removeClass("is-act");
    $(this).addClass("is-act");
    $(".jsTabBox").removeClass("is-act");
    $(".jsTabBox").eq(index).addClass("is-act");
  });
});
